import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressiveImage from './ProgressiveImage';

function Showreel({ media, homepageItems = [] }) {
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState(null);

  const activeItem = useMemo(() => {
    if (!homepageItems.length) return null;
    return homepageItems.find((item) => item.id === hoveredId) || null;
  }, [homepageItems, hoveredId]);

  if (homepageItems.length > 0) {
    const openProject = (projectId) => {
      if (projectId) navigate(`/exhibitions/${projectId}`);
    };

    return (
      <main className="homepage-showcase">
        <section className="homepage-list-column" aria-label="Projects">
          <div className="homepage-project-list">
            {homepageItems.map((item) => (
              <button
                key={item.id}
                type="button"
                className="homepage-project-link"
                onMouseEnter={() => setHoveredId(item.id)}
                onMouseLeave={() => setHoveredId(null)}
                onFocus={() => setHoveredId(item.id)}
                onBlur={() => setHoveredId(null)}
                onClick={() => openProject(item.project_id)}
              >
                <span className="homepage-project-title">{item.title}</span>
                {item.subtitle && <span className="homepage-project-subtitle">{item.subtitle}</span>}
              </button>
            ))}
          </div>
        </section>
        <section className="homepage-preview-column" aria-label="Project preview">
          {activeItem?.preview_url && (
            <figure className="homepage-preview-figure">
              <ProgressiveImage
                src={activeItem.preview_url}
                alt={activeItem.title || 'Project preview'}
                style={{ width: '100%', height: '100%', maxHeight: '100%', backgroundColor: 'transparent' }}
                imgStyle={{ objectFit: 'contain' }}
              />
            </figure>
          )}
        </section>
      </main>
    );
  }

  if (!media || media.length === 0) return null;

  const image = media[0];
  const hasLink = image.link_project_id || image.link_url;
  
  const handleImageClick = () => {
    if (image.link_project_id) {
      navigate(`/exhibitions/${image.link_project_id}`);
    } else if (image.link_url) {
      window.open(image.link_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div style={{
      position: 'absolute',
      top: 'var(--header-height, 0px)',
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      boxSizing: 'border-box',
      padding: '24px 0',
      overflow: 'hidden'
    }}>
      <div style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        overflow: 'hidden'
      }}>
        <div style={{
          width: '50%',
          minWidth: '320px',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          boxSizing: 'border-box'
        }}>
          {image.type === 'image' && (
            <figure
              onClick={hasLink ? handleImageClick : undefined}
              style={{
                margin: 0,
                padding: 0,
                width: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: hasLink ? 'pointer' : 'default',
                boxSizing: 'border-box'
              }}
            >
              <ProgressiveImage
                src={image.src}
                alt={image.name || 'homepage'}
                style={{ width: '100%', maxHeight: '100%', backgroundColor: 'transparent' }}
                imgStyle={{ objectFit: 'contain' }}
              />
              {image.name && (
                <figcaption style={{
                  fontFamily: 'Lora, serif',
                  fontSize: '12px',
                  marginTop: '8px',
                  color: '#777',
                  textAlign: 'left',
                  width: '100%'
                }}>
                  {image.name}
                </figcaption>
              )}
            </figure>
          )}
          {image.type === 'video' && (
            <video
              src={image.src}
              controls
              style={{
                width: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
          )}
        </div>
        <div style={{
          width: '50%',
          height: '100%',
          background: '#ffffff'
        }} />
      </div>
    </div>
  );
}

export default Showreel;
